import { searchHubActualites as hubActualitesMapper } from '../helpers/filters/hub-actualites';
import { search } from './search';

export const FILTER_HUB_ACTUS_KEY = 'hub-actualites-filter';
export const searchHubActualites = search(hubActualitesMapper);
